import type { ApiClient } from "../../api";
import {
  deleteApiV1PushSubscriptionsBySubscription,
  getApiV1PushSubscriptions,
  getApiV1NotificationPreferences,
  getApiV1Notifications,
  getApiV1NotificationsUnreadCount,
  getApiV1RealtimeConfig,
  postApiV1NotificationsByNotificationRead,
  postApiV1NotificationsReadAll,
  patchApiV1NotificationPreferences,
  postApiV1PushSubscriptions,
} from "../../api/generated";
import type { NotificationPreferenceInput } from "./types";

export class NotificationsApi {
  constructor(private readonly client: ApiClient) {}

  list(cursor?: string) {
    return getApiV1Notifications(this.client, {
      query: cursor === undefined ? undefined : { cursor },
    });
  }

  unreadCount() {
    return getApiV1NotificationsUnreadCount(this.client);
  }

  markRead(id: string) {
    return postApiV1NotificationsByNotificationRead(this.client, {
      path: { notification: id },
    });
  }

  markAllRead() {
    return postApiV1NotificationsReadAll(this.client);
  }

  preferences() {
    return getApiV1NotificationPreferences(this.client);
  }

  /**
   * Сохранить настройки перечисленных событий.
   *
   * Присланные события перезаписываются, остальные остаются как были: экран
   * сохраняет по одной галочке, и полная замена сносила бы всё остальное.
   */
  updatePreferences(preferences: NotificationPreferenceInput[]) {
    return patchApiV1NotificationPreferences(this.client, {
      body: { preferences },
    });
  }

  registerPush(input: {
    endpoint: string;
    keys: { p256dh: string; auth: string };
    content_encoding?: string;
    device_name?: string;
  }) {
    return postApiV1PushSubscriptions(this.client, { body: input });
  }

  /** Устройства, на которые приходят браузерные уведомления. */
  pushSubscriptions() {
    return getApiV1PushSubscriptions(this.client);
  }

  unregisterPush(id: string) {
    return deleteApiV1PushSubscriptionsBySubscription(this.client, {
      path: { subscription: id },
    });
  }

  realtimeConfig() {
    return getApiV1RealtimeConfig(this.client);
  }
}
